export const LOCATION_ROUTE = '/location'
export const BACKEND_ROUTE = '/backend'